import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/feather2.png'


const _withScopeId = n => (_pushScopeId("data-v-6888188a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "viesti",
  class: "AngelMessageArea NormalPaddings"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "ExpandableArea" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Vaihtuva viesti enkeleiltä", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Pahus! Nyt pätkii sen verran pahasti, etten löydä viestiäsi. Kannattaa yrittää myöhemmin uudelleen. ", -1))
const _hoisted_9 = [
  _hoisted_8
]

import { reactive } from "vue";
import Proxy from "../api/proxy";
import { Message } from "../models/Message";

interface State {
  showMessage: boolean;
  showError: boolean;
  HtmlContent: string;
  Title: string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = reactive<State>({
  showMessage: false,
  showError: false,
  HtmlContent: "",
  Title: "",
});

const proxy = new Proxy();

function setMessage(title: string, lines: string[]): void {
  state.Title = title;
  let html = "";
  lines.forEach((line) => {
    html += line + "<br/>";
  });
  state.HtmlContent = html;
  state.showMessage = true;
}

function showMessageClicked(): void {
  getMessage();
}

function getMessage(): void {
  proxy
    .angelMessage()
    .then((response: Message) => {
      state.showError = false;
      setMessage(response.title, response.lines);
    })
    .catch(() => {
      state.showError = true;
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_unref(state).showMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h1", null, _toDisplayString(_unref(state).Title), 1),
                  _createElementVNode("p", null, [
                    _createElementVNode("span", {
                      innerHTML: _unref(state).HtmlContent
                    }, null, 8, _hoisted_4)
                  ])
                ]),
                _createElementVNode("img", {
                  class: "clickableimage",
                  src: _imports_0,
                  onClick: showMessageClicked,
                  alt: "klikattava höyhen"
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    class: "clickableimage",
                    src: _imports_0,
                    onClick: showMessageClicked,
                    alt: "klikattava höyhen"
                  })
                ]),
                _createElementVNode("div", {
                  class: "clicktext",
                  onClick: showMessageClicked
                }, " Klikkaa höyhentä avataksesi viestin ")
              ]))
        ]),
        _: 1
      }),
      (_unref(state).showError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})